import { render } from "./DetailStoreHeader.vue?vue&type=template&id=c4214806&scoped=true"
import script from "./DetailStoreHeader.vue?vue&type=script&lang=js"
export * from "./DetailStoreHeader.vue?vue&type=script&lang=js"

import "./DetailStoreHeader.vue?vue&type=style&index=0&id=c4214806&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4214806"]])

export default __exports__